import React, { useContext, useEffect, useState } from "react";
import { debounce } from "lodash";
import { Heading, RichTextEditor, SectionHeading, SectionSamples } from "../../../components";
import Input from "../../../components/Input/Input";
import styles from "./EducationForm.module.css";
import { ResumeContext } from "../../../contexts/resumeContext";
import { ChevronDown, ChevronUp, deleteIcon, Plus, plus } from "../../../components/Icons/Icons";

const newEducationBlock = {
  institute: "",
  degree: "",
  location: "",
  description: "",
};

function EducationForm() {
  const { resumeInfo, updateResumeInfo } = useContext(ResumeContext);
  const [additionalDetailsVisible, showAdditionalDetails] = useState(false);
  const [educationDetails, setEducationDetails] = useState(
    Object.values(
      resumeInfo.educationDetails || { 0: { ...newEducationBlock } }
    ) || [{}]
  );

  useEffect(() => {
    updateResumeInfo.current("educationDetails", educationDetails, resumeInfo);
  }, [educationDetails]);

  const handleChange = (e, ix) => {
    let educationDetailsArr = [...educationDetails];
    let educationDetailsObj = educationDetailsArr[ix];
    educationDetailsObj[e.target.name] = e.target.value;
    educationDetailsArr[ix] = educationDetailsObj;
    setEducationDetails(educationDetailsArr);
  };

  const addBlock = () => {
    let educationDetailsArr = [...educationDetails, {}];
    setEducationDetails(educationDetailsArr);
  };

  const deleteBlock = (ix) => {
    const educationDetailsArr = [...educationDetails];
    educationDetailsArr.splice(ix, 1);
    setEducationDetails(educationDetailsArr);
  };

  return (
    <div>
      <SectionHeading
        editable
        section="AD"
        content="Academic Details"
        subheading={<>A varied education on your resume sums up the value that your learnings and background will bring to job. <SectionSamples section="ED"/></>}
      />
      {educationDetails?.map((ed, ix) => (
        <div className="block" key={ix}>
          <button className="delete-btn" onClick={() => deleteBlock(ix)}>
            <img src={deleteIcon} />
          </button>
          <div className="row">
            <div className="col">
              <Input
                label="School/College/Institute"
                name="institute"
                onChange={(e) => handleChange(e, ix)}
                value={ed.institute}
              />
            </div>
            <div className="col">
              <Input
                label="Class/Degree/Course"
                name="degree"
                onChange={(e) => handleChange(e, ix)}
                value={ed.degree}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="Start Date"
                name="startDate"
                placeholder="MM/YYYY"
                type="month"
                onChange={(e) => handleChange(e, ix)}
                value={ed.startDate}
              />
            </div>
            <div className="col">
              <Input
                label="End Date"
                name="endDate"
                placeholder="MM/YYYY"
                type="month"
                onChange={(e) => handleChange(e, ix)}
                value={ed.endDate}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="Location"
                name="location"
                onChange={(e) => handleChange(e, ix)}
                value={ed.location}
              />
            </div>
          </div>
          {additionalDetailsVisible == `ed_${ix}` && (
            <div className="row">
              <RichTextEditor
                placeholder="Enter your CGPA if it's higher than 9/10. Enter course modules if relevant to your profile"
                value={ed.description || ""}
                onChange={(value) =>
                  handleChange({ target: { name: "description", value } }, ix)
                }
              />
            </div>
          )}
          <button
            className="link"
            onClick={() =>
              showAdditionalDetails(
                additionalDetailsVisible == `ed_${ix}` ? false : `ed_${ix}`
              )
            }
          >
            {additionalDetailsVisible == `ed_${ix}` ? "Hide" : "Add"} additional details {additionalDetailsVisible == `ed_${ix}` ? <ChevronUp /> : <ChevronDown />}
          </button>
        </div>
      ))}
      <button className="link" onClick={addBlock}>
        Add More Education <Plus />
      </button>
    </div>
  );
}

export default EducationForm;
